import React from "react";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";

export default function ToastMessage({ data, setData }) {
  const { vertical, horizontal, open } = data;
  const handleClose = () => {
    setData({ ...data, open: false });
  };
  return (
    <Box sx={{ width: 500 }}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        message="Please Choose Any Platform"
        key={vertical + horizontal}
      />
    </Box>
  );
}
